<template>
  <van-popup v-model="visible" :style="{height:'100vh',background:'#f6f5f5'}" position="bottom">
    <header class="wh-flex-between">
      <div />
      库存明细
      <van-icon color="#20caa0" name="close" @click="hidePopup" />
    </header>
    <wh-mobile-list :extra-params="{id:listId}" data-src="/api/getParPreparedProductsRecords">
      <template v-slot="{list}">
        <div class="list">
          <div v-for="i in list" :key="i.id" class="card wh-flex-between">
            <div :style="{background:/入/.test(i.stockType)?'#20caa0':'#c42b1c'}" class="type">
              {{ i.stockType }}
            </div>
            <div :style="{color:i.quantity>0?'#20caa0':'#c42b1c'}">
              {{ i.quantity + i.unit }}
            </div>
            <div class="per-time">
              <span>操作人：{{ i.operator }}</span><span>{{ i.operatorTime }}</span>
            </div>
          </div>
        </div>
      </template>
    </wh-mobile-list>
  </van-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'

export default {
  name: 'ProductStockList',
  components: { WhMobileList },
  mixins: [formPopup],
  props: {
    listId: {
      type: Number,
      default: undefined
    }
  }
}
</script>

<style lang="less" scoped>
header {
  background: #FFFFFF;
  padding: 12px;
  font-size: 20px;
}
.list {
  display: grid;
  grid-row-gap: 12px;
  padding: 12px;
  .card {
    background: #FFFFFF;
    padding: 12px;
    .type {
      color: #FFFFFF;
      padding: 3px;
    }
    .per-time {
      display: grid;
      grid-row-gap: 5px;
    }
  }
}
</style>
